import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Trash2, Repeat, Calendar } from 'lucide-react';

export const DeleteRecurringTaskDialog = ({ show, onHide, onDeleteInstance, onDeleteSeries }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title className="h5">Delete Recurring Task</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>This is a recurring task. Do you want to delete only this occurrence or the entire series?</p>

                <div className="d-flex flex-column gap-2 mt-3">
                    <Button
                        variant="outline-danger"
                        onClick={onDeleteInstance}
                        className="d-flex align-items-center justify-content-between p-3 text-start hover-bg-light"
                    >
                        <div className="d-flex align-items-center gap-3">
                            <Calendar size={20} />
                            <div>
                                <div className="fw-semibold">Delete this occurrence</div>
                                <div className="small opacity-75">Mark this task as cancelled and create the next one.</div>
                            </div>
                        </div>
                    </Button>

                    <Button
                        variant="outline-danger"
                        onClick={onDeleteSeries}
                        className="d-flex align-items-center justify-content-between p-3 text-start"
                    >
                        <div className="d-flex align-items-center gap-3">
                            <Repeat size={20} />
                            <div>
                                <div className="fw-semibold">Delete entire series</div>
                                <div className="small opacity-75">Remove this and all future occurrences.</div>
                            </div>
                        </div>
                    </Button>
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
